<template>
  <table
      class="table table-sm bg-white borderless box-print"
      style="border: 0; padding: 0;"
      id="boxPrint"
  >
    <tbody>
    <tr>
      <td id="headerprint">
        <print-header></print-header>
      </td>
    </tr>
    <tr>
      <td style="border: 0; padding: 0;">
        <slot name="datas"></slot>
      </td>
    </tr>
    <tr>
      <td style="border: 0; padding: 0;">
        <div id="reportprint">
          <div id="bodyprint">
            <slot></slot>
          </div>
        </div>
      </td>
    </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: "PrintContent",
};
</script>

<style scoped>
@media print {
  table {
    font-size: 16px;
    color: black !important;
  }
}
</style>
